<template>
  <wui-modal
    :title="t('calls.deletedConferenceTitle')"
    :size="40"
    class="!w-[350px] phone:!w-[320px]"
  >
    <p class="text-body-r-14-20 text-fg-base-fg10">
      {{ t('calls.deletedConferenceInHistory', { name: roomName }) }}
    </p>

    <template #footer>
      <wui-btn
        :size="40"
        variant="neut"
        state="alpha"
        @click="closeDialog(undefined)"
      >
        {{ t('common.close') }}
      </wui-btn>
    </template>
  </wui-modal>
</template>

<script setup lang="ts">
import { closeDialogKey, safeInject, WuiBtn, WuiModal } from '@wui/common-library'

import { useLocalization } from '@/shared/composables/localization'

defineProps<{
  roomName: string
}>()

const { t } = useLocalization()
const closeDialog = safeInject(closeDialogKey)
</script>
